import { render, staticRenderFns } from "./kurulamayanlar.vue?vue&type=template&id=0916fb58"
import script from "./kurulamayanlar.vue?vue&type=script&lang=js"
export * from "./kurulamayanlar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports